import FreeAlternatives from './FreeAlternatives'

export default FreeAlternatives
